<template>
  <b-modal id="quit-confirm-modal" hide-footer hide-header>
    <div class="d-block text-center">
      <div class="title">{{ $t("quit_confirm_title") }}</div>
      <div class="sub-title">{{ $t("quit_confirm_text") }}</div>
    </div>
    <b-container class="padding-top-modal" fluid="sm">
      <div class="mb-1 d-flex align-items-center justify-content-around">
          <b-button class="width-button-modal" variant="primary-inverse" @click="$bvModal.hide('quit-confirm-modal')">
            {{ $t("button_cancel") }}
          </b-button>
          <b-button class="width-button-modal" @click="quitTest()" variant="primary">
            {{ $t("button_quit") }}
          </b-button>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import {Storage} from "../../../core/Utils";
import router from "../../../router";

export default {
  name: "QuitConfirmModal",
  methods: {
    quitTest() {
      Storage.removeItemAnswers();
      router.push({name: 'Welcome'})
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/mixins.styl"
@import "~@/core/Styles/variables.styl"

.width-button-modal
  width 150px

.padding-top-modal
  padding-top 100px

.title
  font font-opensans
  font-size 24pt
  font-weight bold

.sub-title
  font font-opensans
  font-size 21pt
</style>
